// Pay It Forward (PIF) related constants

// Minimum USD amount to unlock the "Your Name in the Credits" perk
export const PIF_NAME_IN_CREDITS_MIN_USD = 500

// David trailer video URL and thumbnail
export const DAVID_TRAILER_URL =
  'https://www.youtube-nocookie.com/embed/Sr6OUtx6ZyQ?autoplay=1&playsinline=1&rel=0&modestbranding=1'
export const DAVID_TRAILER_THUMBNAIL =
  'https://images.angelstudios.com/image/upload/v1761150935/theatrical/david/david-1m-promo-img-philc-placeholder'
